import { RootState } from '@src/store/store'
import { initialState } from './reducer'

export const selectAuth = (state: RootState) => state.isAuth || initialState
export const selectIsLoading = (state: RootState): boolean => selectAuth(state).isLoading
export const selectAuthConfirmAction = (state: RootState) => selectAuth(state).confirmAction
export const selectAuthConfirmActionCard = (state: RootState) => selectAuth(state).confirmActionCard
export const selectAuthSuccessRegistration = (state: RootState) => selectAuth(state).registerSuccess
export const selectAuthConfirmPhone = (state: RootState) => selectAuth(state).confirmPhone
export const selectCodesPhone = (state: RootState) => selectAuth(state).codes
export const selectBackError = (state: RootState) => selectAuth(state).backError
export const selectRecallPassword = (state: RootState) => selectAuth(state).successRecallPassword
export const selectRecoveryPassword = (state: RootState) => selectAuth(state).successRecoveryPassword
export const selectSecondStep = (state: RootState) => selectAuth(state).confirmCardCode
export const selectStep = (state: RootState) => selectAuth(state).step
export const selectPhone = (state: RootState) => selectAuth(state).phoneForSms
